import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-214" data-mp="26z7muryed7ce">
      <KanjiBackdrop glyphs={['痛', '疾', '虛', '滯', '亂']} data-id="element-215" data-mp="26y60vsfuf0fw" />
      <div className="text-center" data-id="element-216" data-mp="2bwqzjnfg5c28">
        <p className="font-kanji text-xl text-brand-goldDark/70" aria-hidden="true" data-id="element-217" data-mp="2bvoc5phc1rr2">
          問
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold leading-tight text-brand-ink md:text-5xl" data-id="element-218" data-mp="21z35z0tkualn">
          ¿A cuántos pacientes más vas a atender sin el sistema visual que tu
          práctica merece?
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-219" data-mp="1sxv8um2srft5">
          <p data-id="element-220" data-mp="3iemkzz2ce593">
            Eres terapeuta de acupuntura o digitopuntura. Invertiste años en tu
            formación. Conoces los meridianos, entiendes el Qi, sabes dónde
            están los puntos.
          </p>
          <p data-id="element-221" data-mp="1yz3wix84u2gb">
            Crees en el poder de la medicina ancestral. En que el cuerpo tiene
            todas las respuestas. En que una aguja en el lugar correcto cambia
            todo.
          </p>
          <p className="font-semibold" data-id="element-222" data-mp="27sh0cu7qioh6">
            Pero hay algo que ningún libro de medicina china te dio:
          </p>
          <p className="font-semibold text-brand-forest" data-id="element-223" data-mp="23trbo5h8xki8">
            Un sistema visual clínico, rápido y preciso para usar dentro de la
            sesión.
          </p>
          <p className="text-brand-muted" data-id="element-224" data-mp="1b4amrhsu4lqr">
            No para estudiar. No para repasar. Para usar mientras el paciente
            está en la camilla.
          </p>
          <p className="font-display text-lg italic text-brand-cinnabar" data-id="element-225" data-mp="1k34rjvgbkife">
            Y esa diferencia la sientes cada vez que:
          </p>
        </div>
      </div>
      <div className="paper-card mt-8 rounded-sm border border-brand-cinnabar/30 p-5 shadow-[0_10px_30px_rgba(44,38,32,0.08)] md:p-7" data-id="element-226" data-mp="30jh18warrc4m">
        <h3 className="flex items-center gap-2 font-serif text-base font-bold uppercase tracking-[0.06em] text-brand-ink md:text-lg" data-id="element-227" data-mp="1t5y7cgu3670w">
          <XIcon className="h-5 w-5 text-brand-cinnabar" aria-hidden="true" data-id="element-228" data-mp="1y2ex1fgxotg3" />
          Lo que pasa sin el Atlas Ancestral™
        </h3>
        <span className="fret-rule mt-3 block w-full opacity-50" aria-hidden="true" data-id="element-229" data-mp="274y122wghc3x" />
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 md:gap-x-6 md:gap-y-4" data-id="element-230" data-mp="1af73tvws5auf">
          {painPoints.map(point => <li key={point} className="flex gap-2.5 text-[13px] leading-snug text-brand-text md:text-sm" data-id="element-231" data-mp="1ehag2mr9wjgr">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-cinnabar" aria-hidden="true" data-id="element-232" data-mp="1jdirpq69huj6" />
              <span data-id="element-233" data-mp="qpmy4ubzoiqm">{point}</span>
            </li>)}
        </ul>
      </div>
      <p className="mt-10 text-center font-display text-2xl font-bold italic text-brand-cinnabar md:text-3xl" data-id="element-234" data-mp="vp9dpafaib2l">
        ¿Y si esta fuera la última sesión que trabajas sin un atlas visual
        clínico completo?
      </p>
    </Section>;
}